import { useRef, useState } from "react";

type Props = {
  onCapture: (dataUrl: string) => void;
  label?: string;
  disabled?: boolean;
};

async function compress(file: File): Promise<string> {
  const bitmap = await createImageBitmap(file);
  const max = 1280;
  const ratio = Math.min(1, max / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(bitmap.width * ratio));
  canvas.height = Math.max(1, Math.round(bitmap.height * ratio));
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Não foi possível processar a foto.");
  ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL("image/jpeg", 0.72);
}

export function CameraCapture({ onCapture, label = "Adicionar foto", disabled = false }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);

  return (
    <>
      <input
        ref={inputRef}
        className="sr-only"
        type="file"
        accept="image/*"
        capture="environment"
        onChange={async (event) => {
          const file = event.target.files?.[0];
          if (!file) return;
          setBusy(true);
          try {
            onCapture(await compress(file));
          } finally {
            setBusy(false);
            event.target.value = "";
          }
        }}
      />
      <button className="secondary" type="button" disabled={busy || disabled} onClick={() => inputRef.current?.click()}>
        {busy ? "Processando..." : disabled ? "Fotos indisponíveis" : "📷 " + label}
      </button>
    </>
  );
}
